import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../../../../DatiSegnalazioneAnagrafici/DatiSegnalazioneAnagrafici.module.css";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import Input from "../../../../../../../components/textbox/Input";
import Utils from "../../../../../../../utils/Utils";
import Calendar from "../../../../../../../components/calendar/Calendar";
import SelectAutocomplete from "../../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../../utils/Ruoli";

class DatiSegnalazioneMorbillo extends Component {

    state = {
        datiSegnalazione: {
            regione: "",
            ulss: "",
            comune: "",
            medicoSegnalatore: "",
            dataSegnalazioneUlss: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni,
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),

    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazione) {
            let datiSegnalazione = this.state.datiSegnalazione
            let datiSegnalazioneCopia = this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazione
            datiSegnalazione.ulss = OggettiUtili.ulssMap[datiSegnalazioneCopia.ulss] ? OggettiUtili.ulssMap[datiSegnalazioneCopia.ulss].codice : ""
            datiSegnalazione.comune = this.state.comuniPerCodice[datiSegnalazioneCopia.comune] ? this.state.comuniPerCodice[datiSegnalazioneCopia.comune] : ""
            if (datiSegnalazioneCopia.regione && datiSegnalazioneCopia.regione.length===2){
                datiSegnalazioneCopia.regione=datiSegnalazioneCopia.regione.concat("0")
            }
            datiSegnalazione.regione = this.state.regioni[datiSegnalazioneCopia.regione] ? this.state.regioni[datiSegnalazioneCopia.regione] : ""
            datiSegnalazione.medicoSegnalatore = datiSegnalazioneCopia.medicoSegnalatore ? datiSegnalazioneCopia.medicoSegnalatore : ""
            datiSegnalazione.dataSegnalazioneUlss = datiSegnalazioneCopia.dataSegnalazioneUlss ? datiSegnalazioneCopia.dataSegnalazioneUlss : ""
            this.setState({datiSegnalazione: datiSegnalazione})
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiSegnalazione", oggettoBE, this.state.datiSegnalazione.corretto)
        } else {
            let datiSegnalazione = this.state.datiSegnalazione
            datiSegnalazione.regione = this.state.regioni["050"]
            datiSegnalazione.ulss = OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione] && OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione].codice ? OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione].codice : this.props.segnalazioneCopia.ulssSegnalazione ? this.props.segnalazioneCopia.ulssSegnalazione : ""
            let utente = SessioneUtente.getInstance()
            if (utente) {
                datiSegnalazione.ulss = utente.ulss
            }
            this.setState({datiSegnalazione: datiSegnalazione})
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiSegnalazione", oggettoBE, this.state.datiSegnalazione.corretto)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = (this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || this.props.segnalazioneDatiSpecificiCopia && (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    riceviValore(field, event) {
        let datiSegnalazione = this.state.datiSegnalazione
        datiSegnalazione[field] = event.target.value
        this.setState({datiSegnalazione: datiSegnalazione})
        let oggettoBE = this.createObjectBE()
        let corretto = datiSegnalazione.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("datiSegnalazione", oggettoBE, corretto, this.validate())
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.datiSegnalazione))
        oggettoBE.regione = oggettoBE.regione.codice ? oggettoBE.regione.codice : ""
        oggettoBE.ulss = oggettoBE.ulss.codice ? oggettoBE.ulss : ""
        oggettoBE.comune = oggettoBE.comune.codice ? oggettoBE.comune.codice : ""
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    validate() {

        if (this.state.datiSegnalazione.dataSegnalazioneUlss && Utils.validateDate(this.state.datiSegnalazione.dataSegnalazioneUlss, "Messages.DataSegnalazione", "Messages.DataSegnalazioneOdierna")) {
            return Utils.validateDate(this.state.datiSegnalazione.dataSegnalazioneUlss, "Messages.DataSegnalazione", "Messages.DataSegnalazioneOdierna")
        }

        return ""

    }


    render() {

        let arrayUlss = [];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });

        const {t} = this.props

        const datiSegnalazione = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-3"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.regione")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={stylesWelcome.fieldContainer}>
                            <Autocomplete
                                id={"idRegione"}
                                onChange={this.riceviValore}
                                field={"regione"}
                                keyField={"codice"}
                                disabled={true}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.datiSegnalazione.regione}
                                suggestions={this.state.regioni}
                                placeholder={t("SchedaSpecialeMorbillo.regione")}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-3"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.ulss")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={stylesWelcome.fieldContainer}>
                            <SelectAutocomplete
                                id={"ulss"}
                                disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                field={"ulss"}
                                value={this.state.datiSegnalazione.ulss}
                                onChange={this.riceviValore}
                                functionMap={arrayUlss.map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                                newSelect={true}
                            >
                            </SelectAutocomplete>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-3"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.comune")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <div className={stylesWelcome.fieldContainer}>

                            <Autocomplete id={"idComune"}
                                          value={this.state.datiSegnalazione.comune}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"comune"}
                                          placeholder={t("SchedaSpecialeMorbillo.comune")}
                                          suggestions={this.state.comuni}
                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-3"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.medicoSegnalatore")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Input
                            placeholder={t("SchedaSpecialeMorbillo.medicoSegnalatore")}
                            value={this.state.datiSegnalazione.medicoSegnalatore}
                            id="medicoSegnalatore"
                            field={"medicoSegnalatore"}
                            onChange={this.riceviValore}
                            onValidate={this.state.datiSegnalazione.medicoSegnalatore.startsWith(" ") ? 1 : 2} /// onValidate: 1 errore,  altro valore ok
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                t("SchedaSpecialeMorbillo.medicoSegnalatore"))}
                        />
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-3"}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.dataSegnalazioneUlss")}
                        </p>
                    </div>
                    <div className={"col-lg-4"}>
                        <Calendar
                            id={"dataSegnalazioneUlss"} value={this.state.datiSegnalazione.dataSegnalazioneUlss}
                            field={"dataSegnalazioneUlss"}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataSegnalazioneUlss"))}
                            error={(this.state.datiSegnalazione.dataSegnalazioneUlss === "" || this.state.datiSegnalazione.dataSegnalazioneUlss == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSegnalazione.dataSegnalazioneUlss), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
            </div>
        );

        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.datiSegnalazione")}</h6>
                <hr className={stylesWelcome.hr}/>
                {datiSegnalazione}
            </div>
        );
    }

}

export default withTranslation('common')(DatiSegnalazioneMorbillo)
